import helpers from '../../helpers'

export default {
  "entityName": "returned",
  "upsert": "full",
  // "title": "Site request",
  "pagination": {
    "itemsPerPage": 5,
    "page": 1,
    "sortBy": "id",
    "descending": true
  },
  "fields": [
    {
      "value": "serials_1",
      "text": "Seriali 1",
      validators: ['required', 'serials']
    },
    {
      "value": "serials_2",
      "text": "Seriali 2",
      validators: ['required', 'serials']
    },
    {
      value: "count_serials_1",
      text: 'N. serials 1',
      deps: ['serials_1'],
      default: item => helpers.nSerials(item.serials_1),
    },
    {
      value: "count_serials_2",
      text: 'N. serials 2',
      deps: ['serials_2'],
      default: item => helpers.nSerials(item.serials_2),
    },
    {
      "value": "merge",
      text: 'Merge',
      deps: ['serials_1', 'serials_2'],
      default: item => helpers.compatSerials(helpers.mergeSerials(item.serials_1, item.serials_2)),
    },
    {
      value: "count_merge",
      text: 'N. merge',
      deps: ['merge'],
      default: item => helpers.nSerials(item.merge),
      validators: [
        (field, value, item) => {
          return (item.count_merge === item.count_serials_1 + item.count_serials_2) || `${item.count_serials_1}+${item.count_serials_2} !== ${item.count_merge} (should be ${item.count_serials_1+item.count_serials_2})`
        }
      ]
    },
    {
      "value": "subtract",
      text: 'Subtract',
      deps: ['serials_1', 'serials_2'],
      default: item => helpers.compatSerials(helpers.subtractSerials(item.serials_1, item.serials_2)),
    },
    {
      value: "count_subtract",
      text: 'N. subtract',
      deps: ['subtract'],
      default: item => helpers.nSerials(item.subtract),
      validators: [

      ]
    },
    {
      "value": "intersection",
      text: 'Intersection',
      deps: ['serials_1', 'serials_2'],
      default: item => helpers.compatSerials(helpers.serialsAvailability(item.serials_1, item.serials_2)),
    },
    {
      value: "count_intersection",
      text: 'N. intersection',
      deps: ['intersection'],
      default: item => helpers.nSerials(item.intersection),
      validators: [

      ]
    },        

  ],
  actions: ['upsert']
}
